export const NotesModalConsts = {
  TITLE: "Notes",
  WIDTH: "46.875rem",
  NOTES_FIELD_NAME: "notesField",
  SAVE_SUCCESS: "notes saved successfully",
};
